import { useState, useEffect } from 'react';
import supabase from '../../supabase-client.js';

export const useThings = () => {
  const [things, setThings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar todas las cosas
  const fetchThings = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase.rpc('get_all_things');

      if (error) {
        console.error('Error loading things:', error);
        setError('Error al cargar productos');
        return;
      }

      // Mapear los datos para que coincidan con el formato esperado por los componentes
      const mappedThings = (data || []).map(thing => ({
        thing_id: thing.thing_id,
        title_thing: thing.thing_title,
        price_thing: thing.thing_price,
        description_thing: thing.thing_description,
        type_thing: thing.thing_type,
        available_thing: thing.thing_available,
        favorite_product: thing.thing_favorite_product,
        favorite_count_product: thing.thing_favorite_count_product,
        image_urls: thing.thing_image_urls || []
      }));

      setThings(mappedThings);
    } catch (err) {
      console.error('Error fetching things:', err);
      setError('Error al cargar productos');
    } finally {
      setLoading(false);
    }
  };

  // Agregar nueva cosa
  const addThing = async (thingData) => {
    try {
      const { data, error } = await supabase.rpc('create_thing', {
        p_title: thingData.title,
        p_price: parseFloat(thingData.price) || 0,
        p_description: thingData.description || '',
        p_type_thing: thingData.type_thing || '',
        p_available: thingData.available !== false,
        p_image_urls: thingData.image_urls || null
      });

      if (error) {
        console.error('Error creating thing:', error);
        throw new Error(error.message || 'Error al crear producto');
      }

      // Recargar cosas después de crear
      await fetchThings();
      return data;
    } catch (err) {
      console.error('Error adding thing:', err);
      throw err;
    }
  };

  // Actualizar cosa existente
  const updateThing = async (thingId, thingData) => {
    try {
      const { data, error } = await supabase.rpc('update_thing', {
        p_thing_id: thingId,
        p_title: thingData.title,
        p_price: parseFloat(thingData.price) || 0,
        p_description: thingData.description || '',
        p_type_thing: thingData.type_thing || '',
        p_available: thingData.available !== false,
        p_image_urls: thingData.image_urls || null
      });

      if (error) {
        console.error('Error updating thing:', error);
        throw new Error(error.message || 'Error al actualizar producto');
      }

      // Recargar cosas después de actualizar
      await fetchThings();
      return data;
    } catch (err) {
      console.error('Error updating thing:', err);
      throw err;
    }
  };

  // Eliminar cosa
  const deleteThing = async (thingId) => {
    try {
      const { data, error } = await supabase.rpc('delete_thing', {
        p_thing_id: thingId
      });

      if (error) {
        console.error('Error deleting thing:', error);
        throw new Error(error.message || 'Error al eliminar producto');
      }

      // Recargar cosas después de eliminar
      await fetchThings();
      return data;
    } catch (err) {
      console.error('Error deleting thing:', err);
      throw err;
    }
  };

  // Cargar cosas al montar el componente
  useEffect(() => {
    fetchThings();
  }, []);

  // Obtener tipos únicos de type_thing
  const getUniqueTypeThings = () => {
    const uniqueTypes = [...new Set(
      things
        .map(thing => thing.type_thing)
        .filter(type => type && type.trim() !== '')
    )].sort();
    return uniqueTypes;
  };

  return {
    things,
    loading,
    error,
    fetchThings,
    addThing,
    updateThing,
    deleteThing,
    getUniqueTypeThings
  };
};

